import Vue from 'vue'
import App from './App.vue'
import store from './store'
Vue.config.productionTip = false
import router from './router.js';
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import * as echarts from 'echarts';
Vue.prototype.$echarts = echarts;

(function () {
  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = window.config.scLink;
  document.body.appendChild(script);
})();


Vue.use(Element, {
  size: 'medium',
  locale
})
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
